export default function Reducer(state, action) {

    switch (action.type) {
        case 'c82CardsData':
            return ({
                ...state,
                dataC82: action.payload
            });
        case 'c81Dipartimento':
            return ({
                ...state,
                dipartimento: action.payload
            })
        case 'c81SelectedDepartment':
            return ({
                ...state,
                selectedDepartment: action.payload
            });
        case 'c81CardEndpoint':
            return ({
                ...state,
                cardLinkForFiltering: action.payload
            });
        case 'c82NextCardsEndpoint':
            return ({
                ...state,
                cardLinkNextPage: action.payload
            });
        case 'c83BannerData':
            return ({
                ...state,
                c83Data: action.payload
            });
        default:
            return (state);
    }

}
